import request from '@/utils/request'
const apiPath = '/course/courseWelfareClassification'
const courseWelfareClassificationApi = {
  /**
   * 新增【福利分类】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【福利分类】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【福利分类】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  fetchOptions(query) {
    return request.get(apiPath + '/options', { params: query })
  },
  /**
   * 查看【福利分类】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  batchState(data) {
    return request.post(apiPath + '/batchState', data, { isFormData: 1 })
  },
  /**
   * 删除单个【福利分类】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
}
export default courseWelfareClassificationApi
